import React from "react";
import { Button } from "@mui/material";

function RejectButton({ name, icon, handleClick, className, title, disabled }) {
	const handleReject = () => {
		handleClick();
	};
	return (
		<Button
			disabled={disabled}
			name={name}
			variant={"contained"}
			className={` !px-4 !capitalize ${className}`}
			sx={{
				backgroundColor: "#F24822",
				"&:hover": {
					backgroundColor: "#B33519",
					borderColor: "#B33519",
					boxShadow: "none",
				},
				width: 180,
				borderRadius: 3,
				mx: 2,
				py: 1,
			}}
			startIcon={icon}
			onClick={handleReject}>
			{title}
		</Button>
	);
}

export default RejectButton;
